import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectSiteData } from "./site_data/siteDataSlice";
import { resetSnackBar } from "./site_data/siteDataSlice";

export default function MessageSnackbar() {
  const dispatch = useDispatch();
  const { show, message, severity } = useSelector(selectSiteData);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(resetSnackBar());
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={show}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        elevation={6}
        sx={{
          width: "100%",
          "& .MuiAlert-action": {
            paddingTop: 0,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
